import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "../Icon/SvgIcon.jsx";

import "./styles/style.scss";

const Spinner = ({ isFixed, color }) => {
  const classNames = ["spinner", isFixed && "spinner--fixed"].filter(name => name).join(" ");

  return (
    <div className={classNames}>
      <SvgIcon name="spinner" color={color} />
    </div>
  );
};

Spinner.propTypes = {
  isFixed: PropTypes.bool,
  color: PropTypes.string,
};

Spinner.defaultProps = {
  isFixed: false,
  color: "currentColor",
};

export default Spinner;
